import React, { Component } from 'react'


export default class StatusBoleto extends Component {
    render() {
        return (
            <div className={`container-info  ${this.props.theme}`}>
                <div className="icon">
                    <img src={this.props.image} alt={this.props.altIcon} />
                </div>
                <div className="infos">
                    {this.props.children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/BoxInfos/index.jsx